/** 知识库条目编辑器：编辑 / 预览模式（会话内跨条目保持）。 */
export type KbPageEditorMode = "edit" | "preview";

export const KB_PAGE_EDITOR_MODE_KEY = "c456.kb.pageEditor.mode";

export function readKbPageEditorMode(): KbPageEditorMode {
  // 默认预览：便于扫读；用户点「编辑」后写入 sessionStorage，跨条目保持
  if (typeof sessionStorage === "undefined") return "preview";
  try {
    const raw = sessionStorage.getItem(KB_PAGE_EDITOR_MODE_KEY);
    if (raw === "edit") return "edit";
    if (raw === "preview") return "preview";
    return "preview";
  } catch {
    return "preview";
  }
}

export function writeKbPageEditorMode(mode: KbPageEditorMode): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(KB_PAGE_EDITOR_MODE_KEY, mode);
  } catch {
    // 隐私模式 / 配额不足时忽略；组件内 state 仍可工作
  }
}
